import { render, staticRenderFns } from "./ReportAgent.vue?vue&type=template&id=2c157ca4&scoped=true"
import script from "./ReportAgent.vue?vue&type=script&lang=js"
export * from "./ReportAgent.vue?vue&type=script&lang=js"
import style0 from "./ReportAgent.vue?vue&type=style&index=0&id=2c157ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c157ca4",
  null
  
)

export default component.exports